// Which Beziehung a dynamic price rule is evaluated with. The engine takes exactly one
// relation; by default that is the booking's own. A rule may however name other
// relations (e.g. "Tagesgastlieger mit Segelboot" / "…mit Motorboot" on a product
// attached to "Tagesgastlieger M/S") — then the booking's relation can never match and
// the user has to pick one of the named relations, as on the Bierdeckel. (#7044)

// True when the product's rules name relations and the booking's own is not one of them.
export function needsPricingRelation(
    hasDynamicPrice: boolean | undefined,
    criteriaIds: readonly number[] | undefined,
    bookingRelationId: number | null,
): boolean {
    return !!hasDynamicPrice
        && !!criteriaIds?.length
        && (bookingRelationId == null || !criteriaIds.includes(bookingRelationId));
}

// The relation sent to the engine: the picked one while it is needed and still one of
// the criteria, otherwise the booking's own relation.
export function effectivePricingRelationId(
    hasDynamicPrice: boolean | undefined,
    criteriaIds: readonly number[] | undefined,
    pickedId: number | null | undefined,
    bookingRelationId: number | null,
): number | null {
    if (pickedId != null
        && needsPricingRelation(hasDynamicPrice, criteriaIds, bookingRelationId)
        && criteriaIds?.includes(pickedId)) {
        return pickedId;
    }
    return bookingRelationId;
}
